import {Link} from "react-router-dom";

/**
 * 아카이브 > 동경교과서 협회 중등학교 직원록 중 조선 내 학교 > 리스트 아이템
 */
const MiddleSchoolItem = ({data}) => {

    // // bookId 전달하기 - 전달받은 목차에서 데이터 뿌리기
    // const handleToc = (bookId) => {
    //     onTocClick(bookId);
    // }
    //
    // // year 전달하기
    // const handleInfo = (year) => {
    //     onInfoClick(year);
    // }

    return (
        <>
            {data.map((item, index) => (
                <div className="list-row" key={index} >
                    <Link to={`/archive/middle_school/${item.book_id}`} className="row-link disabled">
                        <div className="title">{item.title}</div>
                        <div className="title-ko bold c-black">{item.book_title_ko}</div>
                        <div className="year">{item.publish_year}</div>
                        <div className="date">{item.publish_date}</div>
                        <div className="publisher">{item.publisher}</div>
                    </Link>

                </div>

            ))}
        </>
    )
}

export default MiddleSchoolItem;